export * from './base.module';
export * from "./v2-details/v2-details.component";
export * from "./v2-details/sign-up-plan-dialog/sign-up-plan-dialog.component";
export * from "./api/subscription-api.module";

export const SubscriptionStatusCodeIncomplete = 0;
export const SubscriptionStatusCodeIncompleteExpired = 1;
export const SubscriptionStatusCodeTrialing = 3;
export const SubscriptionStatusCodeActive = 4;
export const SubscriptionStatusCodePastDue = 5;
export const SubscriptionStatusCodeUnpaid = 6;
export const SubscriptionStatusCodeCanceled = 7;
export const SubscriptionStatusCodeCanceling = 71;
export const SubscriptionStatusCodeArchived = 5;
